var _path, _g, _path2, _path3, _path4, _circle, _path5, _path6, _circle2, _path7, _path8, _g2, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotFoundHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 155,
    viewBox: "0 0 173 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.4591 146.918C119.029 146.918 151.918 114.029 151.918 73.4591C151.918 32.8888 119.029 0 78.4591 0C37.8888 0 5 32.8888 5 73.4591C5 114.029 37.8888 146.918 78.4591 146.918Z",
    fill: "url(#paint0_linear_9615_134362)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9615_134362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.28 61.6562H52.0151C49.405 61.6562 47.2891 63.7722 47.2891 66.3823V123.095C47.2891 125.705 49.405 127.821 52.0151 127.821H145.28C147.89 127.821 150.006 125.705 150.006 123.095V66.3823C150.006 63.7722 147.89 61.6562 145.28 61.6562Z",
    fill: "url(#paint1_linear_9615_134362)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.617 68.0124V123.09C108.617 124.345 108.119 125.548 107.232 126.436C106.344 127.323 105.141 127.821 103.886 127.821H23.6063C22.3515 127.821 21.1481 127.323 20.2608 126.436C19.3735 125.548 18.875 124.345 18.875 123.09V63.7753C18.8741 63.1085 19.0142 62.4492 19.286 61.8404C19.5578 61.2315 19.9552 60.687 20.4521 60.2426L55.8896 28.7321C56.7419 27.9754 57.8387 27.5519 58.9784 27.5393C60.1181 27.5268 61.224 27.9261 62.0928 28.6637L108.412 68.0124H108.617Z",
    fill: "url(#paint2_linear_9615_134362)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1302 86.9844H51C49.8954 86.9844 49 87.8798 49 88.9844V127.805H77.1302V88.9844C77.1302 87.8798 76.2348 86.9844 75.1302 86.9844Z",
    fill: "url(#paint3_linear_9615_134362)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.008 68H108.641V77.5993H150.008V68Z",
    fill: "#393ABD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.617 67.9986V61.6377L62.7969 22.5781H99.0702C100.22 22.5834 101.333 22.9823 102.224 23.7084L154.221 66.1587C154.379 66.2977 154.492 66.481 154.545 66.6847C154.597 66.8885 154.588 67.1033 154.517 67.3015C154.446 67.4997 154.317 67.6721 154.148 67.7964C153.978 67.9207 153.775 67.9911 153.564 67.9986H108.617Z",
    fill: "url(#paint4_linear_9615_134362)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0185 24.4706L62.8842 22.5781L62.8421 22.6202L62.7948 22.5781L59.793 25.2487L12.4169 66.1429C12.26 66.278 12.148 66.4576 12.0956 66.6579C12.0433 66.8582 12.0531 67.0697 12.1239 67.2643C12.1947 67.4589 12.3229 67.6273 12.4917 67.7472C12.6605 67.8671 12.8618 67.9328 13.0688 67.9355L17.9473 67.9986L62.8842 29.3071L108.415 67.9986H108.62L115.98 67.904L65.0185 24.4706Z",
    fill: "url(#paint5_linear_9615_134362)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6564 72.7971C67.6357 72.7971 71.6721 68.7607 71.6721 63.7814C71.6721 58.8021 67.6357 54.7656 62.6564 54.7656C57.6771 54.7656 53.6406 58.8021 53.6406 63.7814C53.6406 68.7607 57.6771 72.7971 62.6564 72.7971Z",
    fill: "url(#paint6_linear_9615_134362)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6911 87H26.7109C25.6064 87 24.7109 87.8954 24.7109 89V110.539C24.7109 111.643 25.6064 112.539 26.7109 112.539H39.6911C40.7956 112.539 41.6911 111.643 41.6911 110.539V89C41.6911 87.8954 40.7956 87 39.6911 87Z",
    fill: "url(#paint7_linear_9615_134362)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9489 95.5312H84.9688C83.8642 95.5312 82.9688 96.4267 82.9688 97.5313V110.511C82.9688 111.616 83.8642 112.511 84.9688 112.511H97.9489C99.0534 112.511 99.9489 111.616 99.9489 110.511V97.5312C99.9489 96.4267 99.0534 95.5312 97.9489 95.5312Z",
    fill: "url(#paint8_linear_9615_134362)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9489 87.0469H84.9688C83.8642 87.0469 82.9688 87.9423 82.9688 89.0469V89.999C82.9688 91.1035 83.8642 91.999 84.9688 91.999H97.9489C99.0534 91.999 99.9489 91.1035 99.9489 89.999V89.0469C99.9489 87.9423 99.0534 87.0469 97.9489 87.0469Z",
    fill: "url(#paint9_linear_9615_134362)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M150.304 107.143C149.838 105.213 147.094 105.213 146.628 107.143L146.355 108.273C146.151 109.116 145.493 109.774 144.651 109.978L143.52 110.251C141.591 110.716 141.591 113.461 143.52 113.927L144.651 114.2C145.493 114.403 146.151 115.061 146.355 115.904L146.628 117.035C147.094 118.964 149.838 118.964 150.304 117.035L150.577 115.904C150.78 115.061 151.439 114.403 152.281 114.2L153.412 113.927C155.341 113.461 155.341 110.716 153.412 110.251L152.281 109.978C151.439 109.774 150.78 109.116 150.577 108.273L150.304 107.143Z",
    fill: "url(#paint10_linear_9615_134362)",
    stroke: "url(#paint11_linear_9615_134362)",
    strokeWidth: 0.420208
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5307 136.596C71.0649 134.666 68.3202 134.666 67.8544 136.596L67.5815 137.726C67.3781 138.569 66.72 139.227 65.8772 139.431L64.7467 139.704C62.8171 140.169 62.8171 142.914 64.7467 143.38L65.8772 143.653C66.72 143.856 67.3781 144.514 67.5815 145.357L67.8544 146.488C68.3202 148.417 71.0649 148.417 71.5307 146.488L71.8036 145.357C72.007 144.514 72.6651 143.856 73.5079 143.653L74.6384 143.38C76.568 142.914 76.568 140.169 74.6384 139.704L73.5079 139.431C72.6651 139.227 72.007 138.569 71.8036 137.726L71.5307 136.596Z",
    fill: "url(#paint12_linear_9615_134362)",
    stroke: "url(#paint13_linear_9615_134362)",
    strokeWidth: 0.420208
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6244 20.6819C28.1586 18.7523 25.414 18.7523 24.9482 20.6819L24.6753 21.8124C24.4718 22.6552 23.8138 23.3133 22.971 23.5167L21.8404 23.7896C19.9108 24.2554 19.9108 27.0001 21.8404 27.4659L22.971 27.7388C23.8138 27.9423 24.4718 28.6003 24.6753 29.4431L24.9482 30.5736C25.414 32.5032 28.1586 32.5032 28.6244 30.5736L28.8973 29.4431C29.1008 28.6003 29.7588 27.9423 30.6016 27.7388L31.7322 27.4659C33.6618 27.0001 33.6618 24.2554 31.7322 23.7896L30.6016 23.5167C29.7588 23.3133 29.1008 22.6552 28.8973 21.8124L28.6244 20.6819Z",
    fill: "url(#paint14_linear_9615_134362)",
    stroke: "url(#paint15_linear_9615_134362)",
    strokeWidth: 0.420208
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.92463,
    cy: 3.92463,
    r: 2.61149,
    transform: "matrix(-1 0 0 1 68.5703 4.48438)",
    stroke: "url(#paint16_linear_9615_134362)",
    strokeWidth: 2.6263
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M158.782 43.5147C159.598 42.919 159.464 41.6626 158.54 41.2531L155.207 39.7762C154.283 39.3667 153.262 40.1113 153.369 41.1164L153.757 44.7415C153.864 45.7466 155.019 46.2585 155.836 45.6629L158.782 43.5147Z",
    fill: "url(#paint17_linear_9615_134362)",
    stroke: "url(#paint18_linear_9615_134362)",
    strokeWidth: 0.875432
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M124.46 133.273C123.48 133.025 122.599 133.93 122.874 134.903L123.865 138.411C124.139 139.384 125.364 139.695 126.069 138.97L128.612 136.358C129.317 135.634 128.974 134.418 127.994 134.169L124.46 133.273Z",
    fill: "url(#paint19_linear_9615_134362)",
    stroke: "url(#paint20_linear_9615_134362)",
    strokeWidth: 0.875432
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.92463,
    cy: 3.92463,
    r: 2.61149,
    transform: "matrix(-1 0 0 1 19.8984 135.773)",
    stroke: "url(#paint21_linear_9615_134362)",
    strokeWidth: 2.6263
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M117.008 123.628L126.54 113.133L153.407 137.472L153.406 137.474L154.841 138.773C156.234 140.035 157.068 141.798 157.159 143.674C157.251 145.55 156.592 147.386 155.329 148.777C154.065 150.168 152.3 151.001 150.422 151.093C148.543 151.184 146.705 150.526 145.312 149.264L143.878 147.965L143.875 147.968L117.008 123.628Z",
    fill: "url(#paint22_linear_9615_134362)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.611 95.4351C136.611 117.391 118.789 135.19 96.8055 135.19C74.8215 135.19 57 117.391 57 95.4351C57 73.4788 74.8215 55.6797 96.8055 55.6797C118.789 55.6797 136.611 73.4788 136.611 95.4351ZM130.505 95.4347C130.505 114.023 115.417 129.092 96.8052 129.092C78.1934 129.092 63.1055 114.023 63.1055 95.4347C63.1055 76.8463 78.1934 61.7773 96.8052 61.7773C115.417 61.7773 130.505 76.8463 130.505 95.4347Z",
    fill: "url(#paint23_linear_9615_134362)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_9615_134362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.8013 129.096C115.413 129.096 130.501 114.027 130.501 95.4386C130.501 76.8502 115.413 61.7812 96.8013 61.7812C78.1895 61.7812 63.1016 76.8502 63.1016 95.4386C63.1016 114.027 78.1895 129.096 96.8013 129.096Z",
    fill: "url(#paint24_linear_9615_134362)",
    fillOpacity: 0.2
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M104.903 95.4356L114.541 85.7884C115.443 84.8341 115.938 83.5657 115.92 82.2528C115.901 80.9399 115.37 79.686 114.441 78.7576C113.511 77.8291 112.256 77.2993 110.941 77.2807C109.627 77.2621 108.357 77.7562 107.401 78.658L97.7418 88.3051L88.1041 78.658C87.6403 78.1678 87.0828 77.7754 86.4646 77.5041C85.8464 77.2329 85.1799 77.0882 84.5047 77.0786C83.8295 77.0691 83.1593 77.1949 82.5336 77.4485C81.9079 77.7022 81.3395 78.0786 80.862 78.5555C80.3846 79.0324 80.0077 79.6 79.7537 80.2249C79.4997 80.8498 79.3738 81.5193 79.3833 82.1936C79.3929 82.868 79.5378 83.5335 79.8094 84.151C80.081 84.7685 80.4738 85.3252 80.9646 85.7884L90.6185 95.4356L80.9646 105.083C80.4738 105.546 80.081 106.103 79.8094 106.72C79.5378 107.338 79.3929 108.003 79.3833 108.677C79.3738 109.352 79.4997 110.021 79.7537 110.646C80.0077 111.271 80.3846 111.839 80.862 112.316C81.3395 112.792 81.9079 113.169 82.5336 113.423C83.1593 113.676 83.8295 113.802 84.5047 113.792C85.1799 113.783 85.8464 113.638 86.4646 113.367C87.0828 113.096 87.6403 112.703 88.1041 112.213L97.7634 102.566L107.423 112.213C108.387 113.062 109.64 113.511 110.924 113.469C112.209 113.428 113.43 112.898 114.337 111.989C115.245 111.08 115.771 109.859 115.809 108.576C115.847 107.293 115.393 106.044 114.541 105.083L104.903 95.4356Z",
    fill: "url(#paint25_linear_9615_134362)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9615_134362",
    x: 0.0625,
    y: 14.5781,
    width: 172.516,
    height: 135.242,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.104618 0 0 0 0 0.122267 0 0 0 0 0.545833 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9615_134362"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9615_134362",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_9615_134362",
    x: 48.1016,
    y: 46.7812,
    width: 97.3984,
    height: 97.3125,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_9615_134362"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_9615_134362",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9615_134362",
    x1: 77.8929,
    y1: -23.9201,
    x2: 79.3977,
    y2: 234.057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDBDE7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9615_134362",
    x1: 51.7759,
    y1: 215.765,
    x2: 155.286,
    y2: 213.171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6263D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#393ABD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9615_134362",
    x1: 16.1804,
    y1: 102.739,
    x2: 187.702,
    y2: 119.538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5B6F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9615_134362",
    x1: 56.7587,
    y1: 109.523,
    x2: 72.6512,
    y2: 112.019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7677D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0B0F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9615_134362",
    x1: 88.1115,
    y1: 47.6564,
    x2: 129.755,
    y2: 69.5851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B1E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6263D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_9615_134362",
    x1: 40.7244,
    y1: 47.6564,
    x2: 85.1553,
    y2: 74.1464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B1E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6263D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_9615_134362",
    x1: 45.3469,
    y1: 61.4829,
    x2: 84.2278,
    y2: 85.1643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5149F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_9615_134362",
    x1: 29.3943,
    y1: 101.101,
    x2: 39.0034,
    y2: 102.557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7677D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0B0F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_9615_134362",
    x1: 87.6521,
    y1: 104.907,
    x2: 96.9965,
    y2: 107.036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7677D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0B0F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_9615_134362",
    x1: 87.6521,
    y1: 89.7811,
    x2: 93.7549,
    y2: 94.5502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7677D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0B0F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_9615_134362",
    x1: 138.962,
    y1: 117.367,
    x2: 155.84,
    y2: 85.1949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5149F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_9615_134362",
    x1: 154.499,
    y1: 113.492,
    x2: 139.895,
    y2: 117.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B1E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6263D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_9615_134362",
    x1: 60.1883,
    y1: 146.82,
    x2: 77.067,
    y2: 114.648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5149F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_9615_134362",
    x1: 75.7258,
    y1: 142.945,
    x2: 61.1211,
    y2: 146.751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B1E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6263D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_9615_134362",
    x1: 17.2821,
    y1: 30.9058,
    x2: 34.1607,
    y2: -1.26602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5149F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_9615_134362",
    x1: 32.8195,
    y1: 27.0308,
    x2: 18.2148,
    y2: 30.8367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B1E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6263D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_9615_134362",
    x1: 2.16494,
    y1: 4.33386,
    x2: 6.42465,
    y2: 5.44391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B1E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6263D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_9615_134362",
    x1: 153.307,
    y1: 38.9736,
    x2: 167.384,
    y2: 44.5414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5149F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_9615_134362",
    x1: 155.601,
    y1: 45.2392,
    x2: 153.377,
    y2: 39.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B1E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6263D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_9615_134362",
    x1: 124.459,
    y1: 140.386,
    x2: 119.759,
    y2: 125.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5149F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_9615_134362",
    x1: 127.818,
    y1: 134.621,
    x2: 124.71,
    y2: 140.087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B1E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6263D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_9615_134362",
    x1: 2.16494,
    y1: 4.33386,
    x2: 6.42465,
    y2: 5.44391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B1E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6263D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_9615_134362",
    x1: 123.198,
    y1: 129.257,
    x2: 132.806,
    y2: 118.704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBCBEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8788B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_9615_134362",
    x1: 56.9098,
    y1: 74.0297,
    x2: 137.044,
    y2: 74.5506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDCDF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8485B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_9615_134362",
    x1: 96.8013,
    y1: 61.7812,
    x2: 130.685,
    y2: 149.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_9615_134362",
    x1: 79.5575,
    y1: 79.5483,
    x2: 116.108,
    y2: 113.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF92AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F84B7A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFoundHouse);
export default __webpack_public_path__ + "static/media/not-found-house.d9a7302abd9a9454df6264c63041088a.svg";
export { ForwardRef as ReactComponent };